import { createElement } from "../../../utils/DOMutils";

export default function(form, formElement) {
    const fieldSets = Array.from(formElement.children).filter((ch) =>
        ch.classList.contains("form__field--fieldset")
    );

    if (fieldSets.length === 0) return;

    const submitWrapper = formElement.querySelector(".mktoButtonRow");
    const stepsCount = fieldSets.length;
    let currentStep = 0;

    const getDirectionBoundary = (direction) => {
        if (direction === "prev") return currentStep === 0;
        if (direction === "next") return currentStep === stepsCount - 1;
    };

    const toggleButtonState = (button, condition) => {
        button.disabled = condition;
        button.style.display = condition ? "none" : "initial";
    };

    const toggleButtonsState = () => {
        toggleButtonState(prevButton, getDirectionBoundary("prev"));
        toggleButtonState(nextButton, getDirectionBoundary("next"));
        if (submitWrapper) submitWrapper.style.display = !getDirectionBoundary("next") ? "none" : "initial";
    };

    const toggleStepVisibility = (step, actionType = "add") => {
        if (!fieldSets[step]) return;

        fieldSets[step].style.display = actionType === "add" ? "block" : "none";
    };

    const handleDirectionButtonClick = (direction) => {
        if (direction === "next") {
            form.validate();

            if (fieldSets[currentStep].querySelectorAll(".mktoInvalid").length > 0) return;
        }

        toggleStepVisibility(currentStep, "remove");
        currentStep = direction === "next" ? currentStep + 1 : currentStep - 1;
        toggleStepVisibility(currentStep);
        toggleButtonsState();
    };

    const createDirectionButton = (direction, innerText) => {
        const btn = createElement(
            "button",
            {
                type: "button",
                class: `form__direction-btn form__direction-btn--${direction} link-button link-button--full link-button--no-arrow`,
            },
            innerText
        );

        const arrow = createElement("span", { class: "link-button__arrow" });

        btn[direction === "next" ? "append" : "prepend"](arrow);

        btn.addEventListener("click", handleDirectionButtonClick.bind(null, direction));

        return btn;
    };

    formElement.classList.add("mktoForm--multistep");

    const prevButton = createDirectionButton("prev", "Back");
    const nextButton = createDirectionButton("next", "Next");

    formElement.appendChild(prevButton);
    formElement.appendChild(nextButton);
    toggleStepVisibility(currentStep);
    toggleButtonsState();
}
